import { StyleSheet } from 'react-native';
import { tokens, LILAC_400 } from '@airtel/air-design-system';
export var getHeroLobWidgetStyles = () => {
  var _tokens$spacing = tokens.spacing,
    SPACING_20 = _tokens$spacing.SPACING_20,
    SPACING_16 = _tokens$spacing.SPACING_16;
  return StyleSheet.create({
    container: {
      padding: SPACING_20,
      backgroundColor: LILAC_400
    },
    sectionHeaderPadding: {
      marginBottom: SPACING_16
    },
    propositionCard: {
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    imageContainer: {
      width: 56,
      height: 56
    },
    inViewStyle: {
      height: '100%'
    },
    cardContainer: {
      height: '100%'
    },
    cards: {
      flex: 1,
      marginHorizontal: -20
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      flex: 1
    }
  });
};
export var breakpoints = {
  xs: {
    firstSeekGapSpacing: 20,
    lastSeekGapSpacing: 20,
    slidesPerPage: 2,
    slidesToScroll: 1,
    itemSpacing: 12,
    seekGap: 16
  },
  sm: {
    firstSeekGapSpacing: 20,
    lastSeekGapSpacing: 20,
    itemSpacing: 12,
    slidesPerPage: 2,
    slidesToScroll: 1,
    seekGap: 16
  },
  md: {
    firstSeekGapSpacing: 20,
    lastSeekGapSpacing: 20,
    itemSpacing: 12,
    slidesPerPage: 2,
    slidesToScroll: 1,
    seekGap: 16
  },
  lg: {
    firstSeekGapSpacing: 20,
    lastSeekGapSpacing: 20,
    itemSpacing: 12,
    slidesPerPage: 2,
    slidesToScroll: 1,
    seekGap: 16
  },
  xl: {
    firstSeekGapSpacing: 20,
    lastSeekGapSpacing: 20,
    itemSpacing: 12,
    slidesPerPage: 2,
    slidesToScroll: 1,
    seekGap: 16
  }
};